import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { RowClassArgs, RowArgs, GridComponent } from '@progress/kendo-angular-grid';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { fadeInOnEnterAnimation } from 'angular-animations';
import { ListService } from 'src/app/_services/list.service';
import { environment } from 'src/environments/environment';
import { Asset } from 'src/app/_models/asset';
import { Subscription, forkJoin } from 'rxjs';
import { AssetService } from '../../_services/asset.service';
import { ComponentType } from 'src/app/_models/componentType';
import { ComponentTypeService } from 'src/app/setupClass/_services/componentType.service';
import { DimensionService } from 'src/app/setup/_services/dimension.service';
import { Dimension } from 'src/app/_models/dimension';
import { AssetSearchParams } from 'src/app/_models/assetSearchParams';

@Component({
  selector: 'app-asset-selection-multi',
  templateUrl: './asset-selection-multi.component.html',
  styleUrls: ['./asset-selection-multi.component.scss'],
  animations: [fadeInOnEnterAnimation()]
})
export class AssetSelectionMultiComponent implements OnInit {
  @Output() assetSelect: EventEmitter<[number, number, string]> = new EventEmitter<[number, number, string]>();
  baseUrl = environment.apiUrl;
  @Output()
  assetSelected: EventEmitter<Asset> = new EventEmitter<Asset>();
  assetsSelected: EventEmitter<Array<Asset>> = new EventEmitter<Array<Asset>>();
  @Input()
  method: string;
  make = '';
  model = '';
  description = '';
  componentType = '';
  assetBarCode = '';
  functionalLocation1 = '';
  functionalLocation2 = '';
  functionalLocation3 = '';
  loadingAssets = false;

  componentTypes: ComponentType[];
  dataComponentTypes: Array<ComponentType>;

  fl1: Array<string>;
  fl2: Array<string>;
  fl3: Array<string>;


  dimensions: Dimension[];
  dataDimensions: Array<Dimension>;

  dimensionDataList: any[] = [];

  assetSearchParams: AssetSearchParams = {
    functionalLocation1: '',
    functionalLocation2: '',
    functionalLocation3: '',
    componentType: ''
  };

  @ViewChild('grid', { static: false }) grid: GridComponent;
  private serviceSubscription: Subscription;

  constructor(private componentTypeService: ComponentTypeService, private dimensionService: DimensionService, private listService: ListService, private assetService: AssetService) { }

  ngOnInit() {
    this.method = 'MULTIPLE';
    forkJoin([
      this.componentTypeService.getComponentTypesFull(),
      this.dimensionService.getDimensionsForGrouping(),
      this.assetService.getFunctionalLocation1List(this.assetSearchParams),
      this.assetService.getFunctionalLocation2List(this.assetSearchParams),
      this.assetService.getFunctionalLocation3List(this.assetSearchParams)]
    ).subscribe(([_componentTypes, _dimensions, _fl1, _fl2, _fl3]) => {
      this.componentTypes = _componentTypes;
      this.dataComponentTypes = this.componentTypes.slice();
      this.fl1 = _fl1.slice();
      this.fl2 = _fl2.slice();
      this.fl3 = _fl3.slice();

      this.dimensions = _dimensions;
      this.dataDimensions = this.dimensions.slice();

      this.resetFilter();
    });
  }

  selectAsset(btn, value) {
    this.assetSelected.emit(value);
  }

  selectAssets() {
    if (Array.isArray(this.grid.data)) {
      this.grid.data.forEach((asset: Asset) => {
        this.selectAsset(null, asset);
      });
    } else if (this.grid.data && this.grid.data.data) {
      this.grid.data.data.forEach((asset: Asset) => {
        this.selectAsset(null, asset);
      });
    }
  }

  resetFilter() {
    this.make = '';
    this.model = '';
    this.description = '';
    this.componentType = '';
    this.assetBarCode = '';
    this.functionalLocation1 = '';
    this.functionalLocation2 = '';
    this.functionalLocation3 = '';
  }

  public rowCallback(context: RowClassArgs) {
    const isEven = context.index % 2 === 0;
    return {
      even: isEven,
      odd: !isEven
    };
  }

  handleFilterFuncLoc1(){
    this.componentType = this.componentType ?? '';
    this.functionalLocation1 = this.functionalLocation1 ?? '';
    this.assetSearchParams.functionalLocation1 = this.functionalLocation1;
    this.loadingAssets = true;
    forkJoin([
      this.assetService.getFunctionalLocation2List(this.assetSearchParams),
      this.assetService.getFunctionalLocation3List(this.assetSearchParams),
      this.componentTypeService.getComponentTypesFullWithFilter(this.assetSearchParams)]
    ).subscribe(([_fl2, _fl3, _componentTypes]) => {
      this.fl2 = _fl2.slice();
      this.fl3 = _fl3.slice();
      this.componentTypes = _componentTypes;
      this.dataComponentTypes = this.componentTypes.slice();
      this.refreshData();
    });
  }

  handleFilterFuncLoc2(){
    this.componentType = this.componentType ?? '';
    this.functionalLocation2 = this.functionalLocation2 ?? '';
    this.assetSearchParams.functionalLocation2 = this.functionalLocation2;
    this.loadingAssets = true;
    forkJoin([
      this.assetService.getFunctionalLocation1List(this.assetSearchParams),
      this.assetService.getFunctionalLocation3List(this.assetSearchParams),
      this.componentTypeService.getComponentTypesFullWithFilter(this.assetSearchParams)]
    ).subscribe(([_fl1, _fl3, _componentTypes]) => {
      this.fl1 = _fl1.slice();
      this.fl3 = _fl3.slice();
      this.componentTypes = _componentTypes;
      this.dataComponentTypes = this.componentTypes.slice();
      this.refreshData();
    });
  }

  handleFilterFuncLoc3(){
    this.componentType = this.componentType ?? '';
    this.functionalLocation3 = this.functionalLocation3 ?? '';
    this.assetSearchParams.functionalLocation3 = this.functionalLocation3;
    this.loadingAssets = true;
    forkJoin([
      this.assetService.getFunctionalLocation1List(this.assetSearchParams),
      this.assetService.getFunctionalLocation2List(this.assetSearchParams),
      this.componentTypeService.getComponentTypesFullWithFilter(this.assetSearchParams)]
    ).subscribe(([_fl1, _fl2, _componentTypes]) => {
      this.fl1 = _fl1.slice();
      this.fl2 = _fl2.slice();
      this.componentTypes = _componentTypes;
      this.dataComponentTypes = this.componentTypes.slice();
      this.refreshData();
    });
  }

  handleFilterComponentType() {
    this.assetSearchParams.componentType = this.componentType;
    this.loadingAssets = true;
    forkJoin([
      this.assetService.getFunctionalLocation1List(this.assetSearchParams),
      this.assetService.getFunctionalLocation2List(this.assetSearchParams),
      this.assetService.getFunctionalLocation3List(this.assetSearchParams)]
    ).subscribe(([_fl1, _fl2, _fl3]) => {
      this.fl1 = _fl1.slice();
      this.fl2 = _fl2.slice();
      this.fl3 = _fl3.slice();
      this.refreshData();
    });
  }

  handleDimChange(selectedId: any, dimensionDescription: string) {
    dimensionDescription = dimensionDescription.replace(' ', '');
    dimensionDescription = 'Dim' + dimensionDescription + 'Id';
    selectedId = selectedId ? "'" + selectedId + "'" : '';
    const dimensionDataIndex = this.dimensionDataList.findIndex(dim => dim.dimName === dimensionDescription);
    if (selectedId) {
      if (dimensionDataIndex !== -1) {
        this.dimensionDataList[dimensionDataIndex].dimValue = selectedId;
      } else {
        this.dimensionDataList.push({ dimValue: selectedId, dimName: dimensionDescription });
      }
    } else {
      if (dimensionDataIndex !== -1) {
        this.dimensionDataList.splice(dimensionDataIndex, 1);
      }
    }
    this.refreshData();
  }

  refreshData() {
    this.grid.data = null;

    const dimensionFilters = this.dimensionDataList.map(dimension => this.buildFilterString(dimension.dimName, dimension.dimValue));

    const allFilters = [
      ...dimensionFilters,
      this.buildFilterString('Make', "'" + this.make + "'"),
      this.buildFilterString('Model', "'" + this.model + "'"),
      this.buildFilterString('Description', "'" + this.description + "'"),
      this.buildFilterString('ComponentTypeId', "'" + this.componentType + "'"),
      this.buildFilterString('Barcode', "'" + this.assetBarCode + "'"),
      this.buildFilterString('FunctionalLocation1', "'" + this.functionalLocation1 + "'"),
      this.buildFilterString('FunctionalLocation2', "'" + this.functionalLocation2 + "'"),
      this.buildFilterString('FunctionalLocation3', "'" + this.functionalLocation3 + "'")
    ].filter(filter => filter !== '');

    this.filterParams = allFilters.join('~and~');

    this.assetService.getMultiAssetSearch(this.filterParams).subscribe(
      (data) => {
        this.grid.data = data;
        this.loadingAssets = false;
      }
    );
  }

  filterParams: any;

  buildFilterString(filterName: string, filterValue: string) {
    if (filterValue !== '') {
      return filterName + '~contains~' + filterValue;
    }
    return '';
  }
}
